export var USERMANAGEMENT_PATH;
(function (USERMANAGEMENT_PATH) {
    USERMANAGEMENT_PATH["USER_LIST"] = "/users/list";
    USERMANAGEMENT_PATH["USER_ADD"] = "/users/add";
    USERMANAGEMENT_PATH["USER_EDIT"] = "/users/edit";
})(USERMANAGEMENT_PATH || (USERMANAGEMENT_PATH = {}));
export var STATUS_TIME_FORMAT = "DD MMM YYYY, hh:mmA";
